import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { DataProvider } from "./context/DataContext";
import ProtectedRoute from "./components/admin/ProtectedRoute";
import HomePage from "./pages/HomePage";
import CareersPage from "./pages/CareersPage";
import FundraisingPage from "./pages/FundraisingPage";
import MergersAcquisitionsPage from "./pages/MergersAcquisitionsPage";
import BusinessAdvisoryPage from "./pages/BusinessAdvisoryPage";
import LiveDealsPage from "./pages/LiveDealsPage";
import AcademyPage from "./pages/AcademyPage";
import BlogPage from "./pages/BlogPage";
import ReportsPage from "./pages/ReportsPage";
import PodcastsPage from "./pages/PodcastsPage";
import ClientLoginPage from "./pages/ClientLoginPage";
import AdminLoginPage from "./pages/admin/LoginPage";
import AdminDashboard from "./pages/admin/AdminDashboard";
import LegalPage from "./pages/LegalPage";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <DataProvider>
        <BrowserRouter>
          <Toaster position="top-right" expand={true} richColors />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/investment-banking/fundraising" element={<FundraisingPage />} />
            <Route path="/investment-banking/mergers-acquisitions" element={<MergersAcquisitionsPage />} />
            <Route path="/business-advisory" element={<BusinessAdvisoryPage />} />
            <Route path="/live-deals" element={<LiveDealsPage />} />
            <Route path="/academy" element={<AcademyPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/podcasts" element={<PodcastsPage />} />
            <Route path="/client-login" element={<ClientLoginPage />} />
            <Route path="/privacy-policy" element={<LegalPage type="privacy" />} />
            <Route path="/terms-and-conditions" element={<LegalPage type="terms" />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } />
          </Routes>
        </BrowserRouter>
      </DataProvider>
    </div>
  );
}

export default App;
